const WENDEZEIT = 'Dienstfahrt/Wendezt.';
const FAHREN = 'Fahren';

export default {
  /**
   * This function is called while looping through dutyActivities to create a list of duty activities whose activities
   * might merge several items. Each item can have child objects within the children attribute.
   *
   * shouldMergeDutyActivity must check what happens with the currentDutyActivity. However, the function does not
   * manipulate data but needs to return an advice what should be done (described in return)
   *
   * @param {Object} MeinDienst module configuration object
   * @param {Object} accumulator The duty activity which may accumulate other duty activities
   * @param {Object} currentDutyActivity The current duty activity when looping through all activities
   * @param {Array} dutyActivities all duty activities
   * @param {Number} currentIndex the current index when looping through the duty activities
   * @returns string one of the following
   *                 new: that is the current item is used right away
   *                 mergeToAccumulator: the next two items are merged with the current item
   */
  shouldMergeDutyActivity: ({ moduleConfig, accumulator, currentDutyActivity, dutyActivities, currentIndex }) => {
    let i = currentIndex;

    if (!accumulator) {
      // console.debug("shouldMergeDutyActivity returns mergeToAccumulator because accumulator is undefined")
      return 'mergeToAccumulator';
    } else {
      // first draft is analogous to lvb
      if (
        accumulator.course === currentDutyActivity.course &&
        accumulator.line === currentDutyActivity.line &&
        accumulator.blockcode === currentDutyActivity.blockcode &&
        accumulator.toMinutesAfterMidnight === currentDutyActivity.fromMinutesAfterMidnight &&
        accumulator._dutyActivityGroup === currentDutyActivity._dutyActivityGroup
      ) {
        // as long as these conditions are met, the duty activity can be collapsed and thus merged to the accumulator
        // object which collects collapsible items within the children attribute
        // console.debug("shouldMergeDutyActivity returns mergeToAccumulator because merge conditions are met")
        //return 'mergeToAccumulator';
        return 'new';
      }

      return 'new'; // instruction to create a new accumulator, that is a new outer item (collapsible card) is created
    }
  },
  /**
   * Returns the first relevant activity within the given dutyActivities array.
   * The default behavior is to return the first element with a defined blockcode. However this might be specialized by each tenant.
   * @param {Object} MeinDienst module configuration object
   * @param {Array} dutyActivities Array of sorted activities (by time) belonging to one duty
   * @returns dutyActivity declared to be the first relevant
   */
  getFirstActivity: ({ moduleConfig, dutyActivities }) => {
    return dutyActivities[0];
  },
  /**
   * Returns the last duty activity in the sorted list of duty activities.
   * Defaults to return the last activity within the array of activities
   *
   * LVB does not use the last item to determine the end time in some cases.
   * However, the logic is not clear.
   * It seems like LEIB, SANGAusfahrt are blacklisted as last activity within LVB.
   * @param {Object} MeinDienst module configuration object
   * @param {*} dutyActivities
   * @returns the last relevant duty activity
   */
  getLastActivity: ({ moduleConfig, dutyActivities }) => {
    //return dutyActivities[dutyActivities.length - 1];
    return dutyActivities.reverse()[0];
  },
};
